import React, { useEffect } from 'react';
import './invitaciones.css';

const Invitaciones = ({ ciclo, invitaciones }) => {
    useEffect(() => {
       window.scrollTo(0, 0);
    },
     []);

    const invitaciones2018 = invitaciones;

    const click1 = ( procedimiento ) => {
        var aux = document.getElementById( procedimiento ).style;
            aux.display = aux.display == 'block' ? 'none': "block";
    }

    return (    
        <div className='container'>
            <div className='row'>
                <div className='rubros_titulo'>
                    <h2>Histórico de Procedimientos de Invitación a Cuando Menos Tres Personas {ciclo}</h2>
                </div>               
                <div>                  
                    { invitaciones2018.map((item, index)=>( 
                        <>
                            <div className='invitation-container'>
                                <a href="#" onClick={ () => click1 (item.numInvitacion)} >
                                    <p className="invitation-title">{item.numInvitacion}</p>    
                                </a>
                                <div class="invitation" id={item.numInvitacion} style={{display:'none'}}>
                                    { item.procedimiento.map((item1, index1)=>(
                                        <div>
                                            {/* <h5 className="numlicitacion">{item1.numProc}</h5> */}
                                            <h6 className="invitation-validity">{item1.vigenciaProc}</h6>
                                                <div className="invitation-content">
                                                    <div className="invitation-description">
                                                        <p>{item1.descripcionProc}</p>
                                                    </div>
                                                    <div className="invitation-download">
                                                        <a href={item1.urlAnexosProc}>
                                                            <p className='invitation-download-title'>Anexos</p>
                                                            <div className='invitation-icon'><i class="fas fa-download icodescarga"></i></div>
                                                        </a>
                                                    </div>                                                    
                                                    <div className="invitation-results">
                                                        <p class="invitation-download-title">Resultados</p>
                                                        { item1.resultadosProc.map((item2, index2) => ( 
                                                            <>
                                                                <div><a href={ item2.urlResultado } target='_blank' >{ item2.resultado}</a></div>
                                                            </> )) 
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                        ) }
                                              
                                    </div>       
                                </div>
                            </>
                        ) )
                    }
                </div>     
            </div>
        </div>
    )
}

export default Invitaciones